import React from 'react';

const Espaciador = () => {
    return(
        <div className='w-[90%] m-auto h-20'></div>
    )
}

export { Espaciador }